import { otpProcesses } from 'utils/constants';
import {
  UpdatePasswordRequest,
  UpdatePasswordResponse,
} from '../types/profile';
import api from './api';

export const updatePassword = async (
  request: UpdatePasswordRequest,
): Promise<UpdatePasswordResponse> => {
  try {
    const updatePasswordRequest = {
      existingPassword: request.existingPassword,
      newPassword: request.newPassword,
    };

    const result = await api.post(
      `profile/changePassword`,
      updatePasswordRequest,
      {
        headers: {
          'content-type': 'application/json',
          otpFlowTypeCode: otpProcesses.PROFILE_CHANGE_PASSWORD,
          '2fa': request.totp,
        },
      },
    );

    return { statusCode: result?.status, ...result.data };
  } catch (Exception: any) {
    console.error(Exception);
    return {
      success: false,
      message: Exception.response.data as string,
    };
  }
};
